import { Tooltip } from 'antd';
import FiguresTooltip from '../FiguresTooltip';

const ShaftLeakage = props => {
    const { research, scale, minDepth, width, title, date, toDepth } = props;

    const { isInflow, fluid_type } = research;

    const bottom = toDepth(research.bottom);
    const roof = toDepth(research.roof);

    const height = (bottom - roof) * 16 + 24;
    const middleArrow = height / 2;
    const bottomArrowPosition = height - 12;

    if (isInflow) {
        return (
            <Tooltip
                title={
                    <FiguresTooltip
                        title={title}
                        roof={roof}
                        bottom={bottom}
                        date={date}
                        inFlow={isInflow}
                        fluid={fluid_type}
                    />
                }
                styles={{ root: { maxWidth: 'none' } }}
            >
                <svg
                    width={width}
                    height={height}
                    fill="none"
                    style={{
                        position: 'absolute',
                        transform: `translateY(${Math.abs((minDepth - research.roof) * scale - scale + 12)}px)`,
                    }}
                >
                    <g>
                        <path
                            id="top_arrow"
                            fill="#7E8DA9"
                            d="m22,12l-5,-2.88675l0,5.77355l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z"
                        />
                        <path
                            id="middle_arrow_left"
                            fill="#7E8DA9"
                            d={`m22,${middleArrow}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                        />
                        <path
                            id="bottom_arrow"
                            fill="#7E8DA9"
                            d={`m22,${bottomArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                        />
                        <path id="left_line" fill="#7E8DA9" d={`m24.5,0l0,${height}l3,0l0,-${height}l-3,0z`} />
                        <path
                            id="middle_arrow_right"
                            fill="#7E8DA9"
                            d={`m${
                                width - 20
                            },${middleArrow}l5,2.8868l0,-5.7736l-5,2.8868zm4.5,0.5l15.5,0l0,-1l-15.5,0l0,1z`}
                        />
                        <path
                            id="right_line"
                            fill="#7E8DA9"
                            d={`m${width - 21},0l0,${height}l-3,0l0,-${height}l3,0z`}
                        />
                    </g>
                </svg>
            </Tooltip>
        );
    }

    return (
        <Tooltip
            title={
                <FiguresTooltip
                    title={title}
                    roof={roof}
                    bottom={bottom}
                    date={date}
                    inFlow={isInflow}
                    fluid={fluid_type}
                />
            }
            styles={{ minWidth: 'fit-content' }}
        >
            <svg
                width={width}
                height={height}
                fill="none"
                style={{
                    position: 'absolute',
                    transform: `translateY(${Math.abs((minDepth - research.roof) * scale)}px)`,
                }}
            >
                <g>
                    <path
                        id="top_arrow"
                        fill="#7E8DA9"
                        d={`m${width},12l-5,-2.88675l0,5.77355l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path
                        id="middle_arrow_right"
                        fill="#7E8DA9"
                        d={`m${width},${middleArrow}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path
                        id="bottom_arrow"
                        fill="#7E8DA9"
                        d={`m${width},${bottomArrowPosition}l-5,-2.8868l0,5.7736l5,-2.8868zm-4.5,-0.5l-15.5,0l0,1l15.5,0l0,-1z`}
                    />
                    <path id="right_line" fill="#7E8DA9" d={`m${width - 21},0l0,${height}l3,0l0,-${height}l-3,0z`} />
                    <path
                        id="middle_arrow_left"
                        fill="#7E8DA9"
                        d={`m5,${middleArrow}l5,2.8868l0,-5.7736l-5,2.8868zm4.5,0.5l15.5,0l0,-1l-15.5,0l0,1z`}
                    />
                    <path id="left_line" fill="#7E8DA9" d={`m26.5,0l0,${height}l-3,0l0,-${height}l3,0z`} />
                </g>
            </svg>
        </Tooltip>
    );
};

export default ShaftLeakage;
